import { Navigate, useLocation } from "react-router-dom";
import { useAuth, homeFor } from "../lib/auth";
import { Spinner } from "./Bits";

export function RequireRole({ role, children }) {
  const { user, loading } = useAuth();
  const loc = useLocation();
  if (loading) return <Spinner />;
  if (!user) return <Navigate to={`/login?next=${encodeURIComponent(loc.pathname + loc.search)}`} replace />;
  if (!user.role) return <Navigate to="/choose-role" replace />;
  if (role && user.role !== role) return <Navigate to={homeFor(user)} replace />;
  return children;
}
